module.exports = __webpack_public_path__ + "assets/media/lunch.d5a6a877.mp3";